import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { HeroBinder } from '@components/partials/hero-binder/hero-binder';
import { UiModule } from '@components/ui/ui-module';
import { Binder, UserBinder } from '@models/binder.model';
import { BinderService } from '@services/binder.service';
import { Router } from '@services/route.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'lgb-binder-list',
  imports: [
    CommonModule,
    RouterModule,
    HeroBinder,
    UiModule
  ],
  templateUrl: './binder-list.html',
  styleUrl: './binder-list.css',
})
export class BinderList {
  //service
  readonly binderS=inject(BinderService);

  //data
  readonly router=inject(Router);
  readonly route=inject(ActivatedRoute);
  readonly binders=signal<Binder[]>([]);
  readonly uBinders=signal<UserBinder[]>([]);

  //ui
  readonly loading=signal(true);
  readonly fragment=signal<string>(null);

  constructor(){
    //récupération des datas :
    // => binders
    // => userBinder
    this.loading.set(true);

    //récup du fragment
    this.route.fragment.subscribe(fragment => this.fragment.set(fragment));

    forkJoin({
      binders: this.binderS.getBinders(),
      uBinders: this.binderS.getUserBinders()
    }).subscribe(result => {
      this.binders.set(result.binders);
      this.uBinders.set(result.uBinders);
      this.loading.set(false);

      //scroll vers le binder en cas de retour
      if(this.fragment())
        setTimeout(() => document.getElementById(this.fragment())?.scrollIntoView({ behavior: 'instant', block: 'center' }), 200);
    });
  }

  getBinder(uBinder: UserBinder){
    return this.binders().find(b => b.ident==uBinder.binder);
  }
}
